import TranslationReferenceFinder from './TranslationReferenceFinder';
import React, {useEffect, useState} from 'react';
import i18n, {PSEUDO_PREVIEW_AVAILABLE, isPseudoPreviewEnabled, setPseudoPreviewEnabled} from './index';

export default function PseudoPreviewControl() {
    const [enabled, setEnabled] = useState(isPseudoPreviewEnabled);
    const [changing, setChanging] = useState(false);
    const [open, setOpen] = useState(false);
    useEffect(() => {
        const update = () => setEnabled(isPseudoPreviewEnabled());
        i18n.on('languageChanged', update);
        return () => i18n.off('languageChanged', update);
    }, []);
    useEffect(() => {
        if (!PSEUDO_PREVIEW_AVAILABLE) return undefined;
        const show = () => setOpen(true);
        const keys = event => {
            if (event.key === 'Escape') setOpen(false);
            if ((event.ctrlKey || event.metaKey) && event.altKey && event.code === 'KeyL') {
                event.preventDefault();setOpen(previous => !previous);
            }
        };
        window.addEventListener('luckynote:translation-tools', show);
        window.addEventListener('keydown', keys);
        return () => {
            window.removeEventListener('luckynote:translation-tools', show);
            window.removeEventListener('keydown', keys);
        };
    }, []);
    if (!PSEUDO_PREVIEW_AVAILABLE || navigator.userAgent.includes('ReactSnap') || typeof window.snapSaveState === 'function' || !open) return null;
    return <section aria-label="Development translation tools" style={{position: 'fixed', top: 16, right: 16, zIndex: 3000, width: 'min(440px, calc(100vw - 32px))', maxHeight: '80vh', overflowY: 'auto', background: '#142235', color: '#fff', padding: 14, border: '1px solid #82cfff', borderRadius: 8, boxSizing: 'border-box'}}><button type="button" onClick={() => setOpen(false)}>Close translation tools</button><p>Development only · Esc to close</p><button type="button" aria-label={`Dev · Fake language: ${enabled ? 'On' : 'Off'}`} aria-pressed={enabled} disabled={changing}
        title="Development only: highlight translated wording and test longer labels. Click again to restore your selected language."
        onClick={async () => {
            setChanging(true);
            try {setEnabled(await setPseudoPreviewEnabled(!enabled));} finally {setChanging(false);}
        }}
        style={{padding: '8px 12px', borderRadius: 6,
            border: '1px solid #82cfff', background: '#142235', color: '#fff', fontSize: 12, cursor: 'pointer'}}>
        Dev · Fake language: {enabled ? 'On' : 'Off'}
    </button><TranslationReferenceFinder /></section>;
}
